import { clsx } from 'clsx';
import { useId } from 'react';
import * as s from './switch.css';

type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Renders "On" / "Off" (or custom text) left of the knob, as on the automations list. */
  showLabel?: boolean;
  labels?: { on: string; off: string };
  /** Accessible name when there is no visible label to point at. */
  ariaLabel?: string;
  className?: string;
  testId?: string;
};

export const Switch = ({
  checked,
  onChange,
  disabled = false,
  showLabel = false,
  labels = { on: 'On', off: 'Off' },
  ariaLabel,
  className,
  testId = 'switch',
}: SwitchProps) => {
  const id = useId();
  return (
    <label
      htmlFor={id}
      className={clsx(s.wrapper, className)}
      data-disabled={disabled}
      data-testid={testId}
    >
      {showLabel && (
        <span className={s.label({ checked })}>
          {checked ? labels.on : labels.off}
        </span>
      )}
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={s.input}
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={s.track({ checked })} aria-hidden>
        <span className={s.knob({ checked })} />
      </span>
    </label>
  );
};
